import { render, staticRenderFns } from "./LastDownloadedUsers.vue?vue&type=template&id=054a5db1"
import script from "./LastDownloadedUsers.vue?vue&type=script&lang=js"
export * from "./LastDownloadedUsers.vue?vue&type=script&lang=js"
import style0 from "./LastDownloadedUsers.vue?vue&type=style&index=0&id=054a5db1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports